import { AppState } from "../../../state";

export const getBumpScreenMode = (state: AppState) => state.bumpScreen.mode;

export const getOrderHubConnected = (state: AppState) => state.orderHub.status === "connected";

export const getActiveParties = (state: AppState) => state.bumpScreen.activeParties;
